import React from "react";
import { Clock, AlertTriangle, AlertOctagon, CheckCircle2 } from "lucide-react";

const STATES = {
  on_track: { color: "#10B981", bg: "#10B98114", label: "On Track", Icon: CheckCircle2 },
  warning: { color: "#F59E0B", bg: "#F59E0B14", label: "At Risk", Icon: AlertTriangle },
  breached: { color: "#EF4444", bg: "#EF444414", label: "SLA Breach", Icon: AlertOctagon },
  exempt: null,
  unknown: null,
};

function fmt(min) {
  if (min == null) return "—";
  if (min < 1) return "<1m";
  if (min < 60) return `${Math.round(min)}m`;
  const h = Math.floor(min / 60);
  const m = Math.round(min % 60);
  return m === 0 ? `${h}h` : `${h}h ${m}m`;
}

export default function SlaBadge({ sla, testId }) {
  if (!sla) return null;
  const cfg = STATES[sla.state];
  if (!cfg) {
    // exempt / unknown — render a subtle clock with elapsed
    return (
      <span data-testid={testId} className="inline-flex items-center gap-1 text-xs text-[#94A3B8]">
        <Clock className="w-3 h-3" /> {fmt(sla.minutes_elapsed)}
      </span>
    );
  }
  const Icon = cfg.Icon;
  return (
    <span
      data-testid={testId || `sla-${sla.state}`}
      title={`${fmt(sla.minutes_elapsed)} elapsed · threshold ${sla.breach_minutes}m`}
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium whitespace-nowrap"
      style={{ background: cfg.bg, color: cfg.color }}
    >
      <Icon className="w-3 h-3" />
      <span>{cfg.label}</span>
      <span className="opacity-70">· {fmt(sla.minutes_elapsed)}</span>
    </span>
  );
}
